import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dataV from '@jiaminghi/data-view'
import api from './api'
import config from "./config"
import tool, { debounce, throttle } from './utils/tools'
import time from './utils/time'

// 语言切换
import i18n from './language'
// import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/icons/iconfont/iconfont.css"

// import * as Three from 'three'
import Icon from 'vue2-svg-icon/Icon'

import '@/assets/icons/iconfont/iconfont'
import * as echarts from 'echarts'
import http from "./utils/request";

import '@/assets/icons/index';
// import 'default-passive-events'

// 处理Chrome浏览器报错
import VueClipboard from 'vue-clipboard2'
import 'default-passive-events'

// 公共样式
import '@/theme/app.scss'

// 黑暗模式
import '@/theme/theme-drak.scss'
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

// Vue.use(VueI18n)
Vue.use(VueClipboard)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.config.devtools = true;
Vue.use(ElementUI);
Vue.use(dataV)
Vue.prototype.$HTTP = http;
Vue.prototype.$API = api;
Vue.prototype.$TOOL = tool;
Vue.prototype.$CONFIG = config;
Vue.prototype.$TIME = time;
Vue.prototype.$debounce = debounce;
Vue.prototype.$throttle = throttle;
Vue.component('iconTest',Icon);

// 全局错误处理 - 捕获 bezier-curve 相关错误
Vue.config.errorHandler = function (err, vm, info) {
  // 忽略 bezier-curve 的 Invalid array length 错误，这通常是由于容器尺寸为 0 导致的
  if (err && err.message && err.message.includes('Invalid array length')) {
    console.warn('捕获到 bezier-curve 错误（已忽略）:', err.message);
    return;
  }
  // 其他错误正常处理
  console.error('Vue 错误:', err, info);
};

// 捕获未处理的 Promise 错误
window.addEventListener('unhandledrejection', function(event) {
  if (event.reason && event.reason.message && event.reason.message.includes('Invalid array length')) {
    console.warn('捕获到未处理的 Promise 错误（已忽略）:', event.reason.message);
    event.preventDefault();
    return;
  }
});

// 捕获全局错误
window.addEventListener('error', function(event) {
  if (event.error && event.error.message && event.error.message.includes('Invalid array length')) {
    console.warn('捕获到全局错误（已忽略）:', event.error.message);
    event.preventDefault();
    return;
  }
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
